const hasToken = () => Boolean(window.localStorage['Action:token'])

export default hasToken
